'use client'

import { Button } from '@repo/ui/components/button'
import { cn } from '@repo/ui/lib/utils'
import { useRouter } from 'next/navigation'
import { FunctionComponent, useTransition } from 'react'
import { disableDraftMode } from '../../actions/sanity.actions'

const PresentationBanner: FunctionComponent = () => {
  const router = useRouter()
  const [pending, startTransition] = useTransition()

  if (typeof window !== 'undefined' && (window !== window.parent || !!window.opener)) {
    return null
  }

  const disable = () =>
    startTransition(async () => {
      await disableDraftMode()
      router.refresh()
    })

  return (
    <Button variant='defaultAuto' onClick={disable} disabled={pending} className={cn('bottom-miista-page-padding right-miista-page-padding fixed z-50', pending && 'cursor-wait')}>
      {pending ? 'Disabling draft mode...' : 'Disable draft mode'}
    </Button>
  )
}

export default PresentationBanner
